import React, { useCallback, useEffect, useState } from 'react';
import { isEqual } from 'underscore';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { getContextualOptionsAsync } from './contextual-repository';
import { applySelectionToTreeNodes } from './contextual-options-helper';

import { ContextualTarget } from './index';

export const ValidatedContextualTargetInternal = ({ updateValidation, validationProps, ...rest }) => {
  const { data = {} } = validationProps || {};

  const { contextualTargets: contextualTargetsFromProps = [] } = data;

  const [targets, setTargets] = useState(contextualTargetsFromProps);

  const [nodes, setNodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const onDataChange = useCallback((result) => {
    const newData = {
      contextualTargets: result,
    };

    updateValidation([], isEqual(newData, data) ? data : newData);

    if (!isEqual(result, targets)) {
      setTargets(result);
      applySelectionToTreeNodes(nodes, result);
      setNodes([...nodes]);
    }
  }, [data, nodes, targets, updateValidation]);

  useEffect(() => {
    getContextualOptionsAsync().then((options) => {
      setNodes(options);
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      {
        !isLoading && <ContextualTarget {...rest} initialNodes={nodes} setInitialNodes={setNodes} onContextualSelectionChange={onDataChange} contextualSelection={targets} />
      }
    </>
  );
};

ValidatedContextualTargetInternal.propTypes = {
  updateValidation: PropTypes.func.isRequired,
  validationProps: PropTypes.shape({
    contextualTargets: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export const ValidatedContextualTarget = withCustomValidation(ValidatedContextualTargetInternal);
